"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingTransitionAdapter = void 0;
const amplitude_1 = require("./amplitude");
class ReportingTransitionAdapter {
    flag;
    rulaAmplitudeAdapterOptions;
    segment;
    amplitudeAdapter = null;
    constructor(flag, rulaAmplitudeAdapterOptions, segment) {
        this.flag = flag;
        this.rulaAmplitudeAdapterOptions = rulaAmplitudeAdapterOptions;
        this.segment = segment;
    }
    async track(trackEvent) {
        const { amplitude, segment } = await this.currentAdapter();
        amplitude?.track(trackEvent);
        segment?.track(trackEvent);
    }
    async trackLink(event, href, trackEvent) {
        const { amplitude, segment } = await this.currentAdapter();
        amplitude?.track(trackEvent);
        // Workaround for Segment's trackLink method
        // https://github.com/segmentio/analytics-next/issues/1294
        if (this.flag === "segment" || this.flag === "both") {
            event.preventDefault();
            // This timeout mimics the Segment behavior described in:
            // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-link
            setTimeout(() => {
                window.location.href = href;
            }, 300);
        }
        segment?.track(trackEvent);
    }
    async identify(identifyEvent) {
        const { amplitude, segment } = await this.currentAdapter();
        amplitude?.identify(identifyEvent);
        segment?.identify(identifyEvent);
    }
    async page(pageEvent) {
        const { amplitude, segment } = await this.currentAdapter();
        amplitude?.page(pageEvent);
        segment?.page(pageEvent);
    }
    async getOrCreateAmplitudeAdapter() {
        if (!this.amplitudeAdapter) {
            const anonymousId = await this.segment.getAnonymousId();
            const options = {
                ...this.rulaAmplitudeAdapterOptions,
                amplitudeOptions: {
                    ...this.rulaAmplitudeAdapterOptions.amplitudeOptions,
                    deviceId: anonymousId ?? undefined,
                },
            };
            this.amplitudeAdapter = new amplitude_1.RulaAmplitudeAdapter(options);
        }
        return this.amplitudeAdapter;
    }
    async currentAdapter() {
        const amplitude = await this.getOrCreateAmplitudeAdapter();
        if (this.flag === "amplitude") {
            return { amplitude, segment: null };
        }
        if (this.flag === "segment") {
            return { amplitude: null, segment: this.segment };
        }
        if (this.flag === "both") {
            return { amplitude, segment: this.segment };
        }
        return { amplitude: null, segment: null };
    }
}
exports.ReportingTransitionAdapter = ReportingTransitionAdapter;
//# sourceMappingURL=reporting-transition-adapter.js.map